import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import * as UserApi from "features/api/UserApi"
import { publicRoutes } from "router/routes"

import FormElement from "components/Form/FormElement"
import { useAlert } from "hooks/useAlert"
import { useSubdomain } from "hooks/useSubdomain"

const defaultFormFields = {
    password: "",
    passwordConfirmation: ""
}

const defaultFormEvents = {
    ready: true
}

export const FormActivateAccount = ({ accountSlug }) => {
    const [formFields, setFormFields] = React.useState(defaultFormFields)
    const [formEvents, setFormEvents] = React.useState(defaultFormEvents)

    const [errors, setErrors] = React.useState([])
    const [showLocalErrors, setShowLocalErrors] = React.useState(false)
    const [showGlobalError, setShowGlobalError] = React.useState(false)

    const { alert } = useAlert()
    const { t } = useTranslation()
    const { currentSubdomain } = useSubdomain()
	const navigate = useNavigate()

    const handleInputChange = (event) => {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name

        setFormFields({
            ...formFields,
            [name]: value
        })
    }

    const handleValidation = React.useCallback((name, errs) => {
        setErrors((s) => {
            const cleanErrors = [...s.filter((e) => e.origin !== name)]
            return [
                ...cleanErrors,
                ...errs
            ]
        })
    }, [])

    const handleSubmit = async (event) => {
        event.preventDefault()
        // Validate inputs
        const formReady = !(errors.length > 0)

        if (!formReady) {
            setShowLocalErrors(true)
        }
        else {
            try {
                // hide error
                setShowLocalErrors(false)
                // prevent form to be submitted again
                setFormEvents({
                    ...formEvents,
                    ready: false
                })
                
                const password = {
                    password: formFields.password
                }
                const { res: user_info, getError } = await UserApi.activateAccount(accountSlug, password)
                if (getError()) throw getError()
                alert("success", t("activate_account_success", { ns: "auth" }))
                // Redirect to login view
                navigate(publicRoutes.login.path, { user_info })
            } catch (error) {
                console.error(error)
                const erroMsg = error?.message?.toString()
                if (erroMsg) alert("error", erroMsg)

                setShowGlobalError(true)
            } finally {
                setFormEvents(s => ({
                    ...s,
                    ready: true
                }))
            }
        }
    }
    return (
        <form className="form-activate-account">
            {/*fbo - la notification est plus parlante*/}
            {false && showGlobalError &&
                <p className="text-xs text-danger mb-5">{t("activate_account_global_error", { ns: "auth" })}</p>
            }

            {/* Password */}
            <FormElement
                value={formFields.password}
                name="password"
                type="password"
                label={t("new_password", { ns: "auth" })}
                className="mb-2"
                classNameLabel="text-primary"
                passwordCreate={true}
                required={true}
                showErrors={showLocalErrors}
                onValidate={handleValidation}
                onChange={handleInputChange}
            />
            <p className="text-xs mb-12">{t("password_rules", { ns: "auth" })}</p>

            {/* Password confirmation*/}
            <FormElement
                value={formFields.passwordConfirmation}
                name="passwordConfirmation"
                type="password"
                label={t("confirm_password", { ns: "auth" })}
                className="mb-12"
                classNameLabel="text-primary"
                passwordToConfirm={formFields.password}
                required={true}
                showErrors={showLocalErrors}
                onValidate={handleValidation}
                onChange={handleInputChange}
            />

            <div className="flex justify-center mt-7">
                {formEvents.ready &&
                    <button
                        type="submit"
                        className={"c-btn c-btn--primary px-12 " + ((currentSubdomain?.id === "mfc") ? "c-btn--red" : "")}
                        onClick={handleSubmit}
                        style={{ maxWidth: "250px" }}
                    >
                        {t("validate", { ns: "auth" })}
                    </button>
                }
                {!formEvents.ready &&
                    <div className="c-spinner"></div>
                }
            </div>
        </form>
    )
}
